var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{staticClass:"table-box",attrs:{"tooltip-theme":"light","border":"","columns":_vm.columns,"data":_vm.list}}),(_vm.total !== 0)?_c('Page',{staticClass:"pagetion",attrs:{"total":_vm.total,"prev-text":"上一页","next-text":"下一页","show-elevator":"","show-sizer":""},on:{"on-change":_vm.handleChangePage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }